module.exports = __webpack_public_path__ + "img/Character_Ganyu_Thumb.5da7ca06.png";